import {
  EventBusRegistry,
  TimelineAction,
  TimelineActionManager
} from '@fnd/timeline'
import ChatSuggestions from './actions/ChatSuggestions'
import ThinkingIndicator from './actions/ThinkingIndicator'
import MapLocationPicker from './actions/MapLocationPicker'
import DateTimePicker from './actions/DateTimePicker'
import AssistantDispatcher from './AssistantDispatcher'
import ConfirmCreateDemand from './actions/ConfirmCreateDemand'

const ASSISTANT_CHAT_SUGGESTIONS_ID = 'assistant-chat-suggestions'
const ASSISTANT_LOCATION_PICKER_ID = 'assistant-location-picker'
const ASSISTANT_DATETIME_PICKER_ID = 'assistant-datetime-picker'
const ASSISTANT_THINKING_INDICATOR_ID = 'assistant-thinking-indicator'
const ASSISTANT_CONFIRM_CREATE_DEMAND_ID = 'assistant-confirm-create-demand'

class AssistantActionManager extends TimelineActionManager {
  register: EventBusRegistry | undefined

  constructor() {
    super()
    this.register = new AssistantDispatcher().register((event) => {
      if (event.data?.data.metadata?.topic) return
      this.removeThinkingIndicator()
      this.enableChat()
    })
  }

  complete(): void {
    this.register?.unregister()
  }

  addChatSuggestions() {
    this.pushUnique({
      id: ASSISTANT_CHAT_SUGGESTIONS_ID,
      node: ChatSuggestions,
      props: {}
    })
  }

  removeChatSuggestions() {
    this.removeAction(ASSISTANT_CHAT_SUGGESTIONS_ID)
  }

  addLocationPicker(
    variant: string,
    buttonLabel: string,
    position: string = 'center'
  ) {
    this.pushUnique({
      id: ASSISTANT_LOCATION_PICKER_ID,
      node: MapLocationPicker,
      props: {
        variant: variant,
        buttonLabel: buttonLabel,
        position: position
      }
    })
  }

  removeLocationPicker() {
    this.removeAction(ASSISTANT_LOCATION_PICKER_ID)
  }

  addDateTimePicker(buttonLabel: string, position: string = 'center') {
    this.pushUnique({
      id: ASSISTANT_DATETIME_PICKER_ID,
      node: DateTimePicker,
      props: {
        buttonLabel: buttonLabel,
        position: position
      }
    })
  }

  removeDateTimePicker() {
    this.removeAction(ASSISTANT_DATETIME_PICKER_ID)
  }

  addThinkingIndicator() {
    this.pushUnique({
      id: ASSISTANT_THINKING_INDICATOR_ID,
      node: ThinkingIndicator,
      props: {}
    })
  }

  removeThinkingIndicator() {
    this.removeAction(ASSISTANT_THINKING_INDICATOR_ID)
  }

  addConfirmCreateDemand(buttonLabel: string, position: string = 'center') {
    this.pushUnique({
      id: ASSISTANT_CONFIRM_CREATE_DEMAND_ID,
      node: ConfirmCreateDemand,
      props: {
        buttonLabel: buttonLabel,
        position: position
      }
    })
  }

  removeConfirmCreateDemand() {
    this.removeAction(ASSISTANT_CONFIRM_CREATE_DEMAND_ID)
  }

  private pushUnique(action: TimelineAction<any>, push: boolean = true) {
    this.actions = this.actions.filter((a) => a.id !== action.id)
    this.actions.push(action)
    if (push) this.notify()
  }

  public notify() {
    super.notify()
  }
}

export default AssistantActionManager
